import { queue } from "@/rq.js";
import service from "@/service.js";

const getInitialState = () => {
  return {
    bytes_io: null,
    currentTaskId: null
  };
};

const state = getInitialState();

const getters = {
  bytesIO(state) {
    return state.bytes_io;
  },
  dropBytesIO(state) {
    state.bytes_io = null;
  },
};

const mutations = {
  createBytesIO(state, { bytes_io, taskId }) {
    if (taskId === state.currentTaskId) {
      state.bytes_io = bytes_io;
    }
  },
  dropBytesIO(state) {
    state.bytes_io = null;
  },
  setCurrentTaskId(state, { taskId }) {
    state.currentTaskId = taskId;
  },
};

const actions = {
  async CreatePaper({ commit, rootGetters }) {
    const taskId = Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    
    commit("setCurrentTaskId", { taskId });

    try {
      const response = await queue({
        url: "/api/create_paper_queue",
        method: "post",
        data: {
          settings: rootGetters["SettingModule/settings"],
        },
      }).pollBlob({
        url: "/api/create_paper_result/{taskId}",
        options: {
          maxPolls: 600,
          interval: 3000,
        },
      });

      const bytes_io = response.data;
      if (!bytes_io || bytes_io.byteLength === 0) {
        throw new Error("Invalid file data received");
      }
      
      commit("createBytesIO", {
        bytes_io,
        taskId
      });

      if (state.currentTaskId === taskId) {
        return bytes_io;
      } else {
        console.log("Task superseded by newer task, result discarded");
        return null;
      }
    } catch (error) {
      if (state.currentTaskId === taskId) {
        console.error(`Service error (${error.code}):`, error.message);
        throw error;
      } else {
        console.log("Error in superseded task ignored");
        return null;
      }
    }
  },
  async EmailPaper({ rootGetters }) {
    const settings = rootGetters["SettingModule/settings"];
    if (settings.email === "") {
      return;
    }

    try {
      const response = await service({
        url: "/api/email_paper_queue",
        method: "post",
        data: {
          settings: rootGetters["SettingModule/settings"],
        },
      })

      const task = response.data;
      if (!task.task_id) {
        throw new Error("Invalid taskId received");
      }

      return task;
    } catch (error) {
      console.error(`Service error (${error.code}):`, error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};